import React, { FC, useContext } from 'react';

import { mqMin, LucidTheme } from '@lucid/theme';

import ABTestBranch from '../../ab-test-branch/ab-test-branch';
import NavLink from '../../nav/nav-link';
import { ABTestVariation } from '../../ab-test/ab-test';
import { LinkInterface } from '../../../types/types';
import ABTestContext from '../../context/ab-test-context';

interface UniversalLogoButtonProps {
  branch: ABTestVariation;
  buttons: LinkInterface[];
}

const ABTestLoginButton: FC<UniversalLogoButtonProps> = ({ branch, buttons }) => {
  const { branch: activeBranch, hasTriggerFired } = useContext(ABTestContext);
  const isActiveBranch = branch === activeBranch;
  const shouldUpdateStyles = branch === ABTestVariation.B;

  const updatedButtons = buttons.map(button =>
    ['login', 'log-out'].includes(button.entityId as string)
      ? {
          ...button,
          isButton: shouldUpdateStyles,
          secondary: shouldUpdateStyles,
        }
      : button,
  );

  return (
    <>
      {hasTriggerFired && (
        <ABTestBranch
          as="ul"
          branch={branch}
          css={(theme: LucidTheme) => [
            {
              label: 'navMenuButtonUL',
              listStyle: 'none',
              display: isActiveBranch ? 'flex' : 'none',
              alignItems: 'flex-end',
              '& > li:first-of-type': {
                '& > a:not([type=button])': {
                  padding: 0,
                },
              },
              '& > li:last-of-type, li:nth-last-of-type(2)': {
                // TODO: make sure this doesn't break on any specific navs
                width: '100%',
                [mqMin.tabletSmall]: {
                  maxWidth: 'fit-content',
                  alignSelf: 'flex-start',
                },
                '& > a[type=button]': {
                  justifyContent: 'center',
                },
              },
              flexDirection: 'column',
              margin: 0,
              marginBlock: 0,
              paddingInline: 0,
              whiteSpace: 'nowrap',
              padding: `0 ${theme.space.s32}px`,
              borderRight: `1px solid ${theme.colors.coolGrey[40]}`,
              borderBottom: `1px solid ${theme.colors.coolGrey[40]}`,
              borderLeft: `1px solid ${theme.colors.coolGrey[40]}`,
              borderBottomRightRadius: theme.radii.base,
              borderBottomLeftRadius: theme.radii.base,
              [mqMin.tabletLandscape]: {
                gap: theme.space.s24,
                flexDirection: 'row',
                justifyContent: 'flex-end',
                marginBlockStart: 0,
                marginBlockEnd: 0,
                paddingInlineStart: 0,
                height: '100%',
                border: 'unset',
                borderRadius: 'unset',
                padding: 'unset',
              },
            },
            shouldUpdateStyles && {
              gap: theme.space.s24,
              padding: `${theme.space.s24}px ${theme.space.s32}px`,
              [mqMin.tabletSmall]: {
                '& > li:last-of-type, li:nth-last-of-type(2)': {
                  minWidth: '162px',
                },
                flexDirection: 'row',
                justifyContent: 'flex-end',
              },
            },
          ]}
        >
          {updatedButtons.map((buttonLink, index) => (
            <li
              key={`navMenuButton-${buttonLink.entityId}-${index + 1}`}
              css={[
                {
                  label: 'navMenuButtonLi',
                  [mqMin.tabletLandscape]: {
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'flex-end',
                  },
                },
              ]}
            >
              <NavLink css={shouldUpdateStyles && { margin: 0 }} link={buttonLink} />
            </li>
          ))}
        </ABTestBranch>
      )}
    </>
  );
};

export { ABTestLoginButton };
export default ABTestLoginButton;
